<template>
  <div class="content">
    <el-dialog title="确定院校"
               :visible.sync="dialogFormVisible"
               :close-on-click-modal="false"
               width="620px"
               @close="emitClose">
      <el-form :model="form"
               label-width="auto"
               label-position="left"
               size="small"
               ref="formRules"
               :rules="rules">
        <el-form-item label="考研年份"
                      prop="apply_year">
          <el-select v-model="form.apply_year"
                     placeholder="请选择"
                     style="width: 304px">
            <el-option label="2022年"
                       value="2022"></el-option>
            <el-option label="2023年"
                       value="2023"></el-option>
            <el-option label="2024年"
                       value="2024"></el-option>
            <el-option label="2025年"
                       value="2025"></el-option>
            <el-option label="2026年"
                       value="2026"></el-option>
            <el-option label="2027年"
                       value="2027"></el-option>
            <el-option label="2028年"
                       value="2028"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考院校："
                      prop="apply_college_name">
          <el-select v-model="form.apply_college_code"
                     filterable
                     placeholder="请选择"
                     style="width: 100%"
                     clearable
                     @change="collegeChoose">
            <el-option v-for="(item,index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考专业："
                      prop="apply_major_name">
          <el-select filterable
                     placeholder="请选择"
                     v-model="form.apply_major_name"
                     @change="majorChoose"
                     clearable
                     style="width: 100%">
            <el-option v-for="(item,index) in majorOptions"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考学院："
                      prop="apply_academy_name">
          <el-select filterable
                     placeholder="请选择"
                     v-model="form.apply_academy_name"
                     @change="academyChoose"
                     clearable
                     style="width: 100%">
            <el-option v-for="(item,index) in academyOptions"
                       :key="index"
                       :label="item.academy_name"
                       :value="item.academy_code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试方向："
                      prop="apply_direction">
          <el-select v-model="form.apply_direction"
                     placeholder="请选择考试方向"
                     clearable
                     style="width: 100%">
            <el-option v-for="(item,index) in directionsOptions"
                       :key="index"
                       :label="item.direction"
                       :value="{ value: item.direction_code, label: item.direction}">
              <span>{{ `（${item.direction_code}）${item.direction}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="辅导科目"
                      prop="subjects">
          <el-select v-model="form.subjects"
                     multiple
                     placeholder="请选择"
                     style="width: 493px"
                     :disabled="!form.apply_college_code"
                     :multiple-limit="4">
            <el-option v-for="(item, index) in subjectsOptions"
                       :key="index"
                       :label="item.subject_name"
                       :value="item.subject_code">
              <span>{{ `（${item.subject_code}）${item.subject_name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程课时"
                      prop="service_hours">
          <el-input v-model="form.service_hours"
                    clearable
                    style="width: 304px"> <template slot="append">小时</template></el-input>
        </el-form-item>
        <el-form-item label="参考书目：">
          <el-input type="textarea"
                    clearable
                    v-model="form.refer_book"
                    autocomplete="off"
                    placeholder="请输入参考书目"></el-input>
        </el-form-item>
        <el-form-item label="服务备注："
                      prop="applremarky_year">
          <el-input type="textarea"
                    clearable
                    v-model="form.remark"
                    autocomplete="off"
                    placeholder="请输入服务备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="emitClose">取 消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  majorlist,
  collegeList,
  companycourselist,
  subjectlist,
  academylist,
} from '../../../request/api'
import { adminUrl } from '@/utils/helper'

export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      labelWidth: 'left',
      form: this.content,
      majorOptions: [],
      academyOptions: [],
      subjectsOptions: [],
      directionsOptions: [],
      rules: {
        realname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入你的手机号', trigger: 'blur' },
        ],
        wechat: [
          { required: true, message: '请输入你的微信号', trigger: 'blur' },
        ],
        qq: [{ required: true, message: '请输入你的QQ号', trigger: 'blur' }],
        tags: [
          { required: true, message: '请选择你的学员标签', trigger: 'blur' },
        ],
        apply_year: [
          { required: true, message: '请选择你的考研年份', trigger: 'blur' },
        ],
        source: [{ required: true, message: '请选择来源', trigger: 'blur' }],
        products: [
          { required: true, message: '请选择报名课程', trigger: 'blur' },
        ],
        apply_college_name: [
          { required: true, message: '请选择意向院校', trigger: 'blur' },
        ],
        apply_academy_name: [
          { required: true, message: '请选择意向学院', trigger: 'blur' },
        ],
        apply_major_code: [
          { required: true, message: '请选择意向专业', trigger: 'blur' },
        ],
        watcher: [{ required: true, message: '请选择负责人', trigger: 'blur' }],
        subjects: [
          { required: true, message: '请选择辅导科目', trigger: 'blur' },
        ],
        service_hours: [
          { required: true, message: '请输入辅导课时' },
          {
            pattern: /^(\d+|\d+\.\d{1,2})$/,
            message: '输入最多两位小数的数字',
          },
        ],
      },
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
      if (val) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    fetchDetail() {
      this.form = this.content
      if (this.form.apply_college_name && this.form.apply_college_code) {
        this.getMajorOptions()
      }
      if (this.form.apply_major_name && this.form.apply_major_code) {
        this.getMajorInfo(
          this.form.apply_college_code,
          this.form.apply_major_code
        )
      }
      if (this.form.apply_academy_name && this.form.apply_academy_code) {
        this.getSubjectOptions(
          this.form.apply_college_code,
          this.form.apply_academy_code,
          this.form.apply_major_code
        )
      }
      if (this.form.apply_direction_name && this.form.apply_direction_code) {
        this.$set(this.form, 'apply_direction', {
          label: this.form.apply_direction_name,
          value: this.form.apply_direction_code,
        })
      }
      if (this.form.subjects) {
        this.$set(
          this.form,
          'subjects',
          this.form.subjects.map((v) => {
            return v
          })
        )
      }
    },
    emitClose() {
      this.$emit('close')
    },
    // 因为传科目时要上传对象所以在这里做一些处理
    formateSubjects() {
      let arr = []
      this.form.subjects.forEach((item) => {
        let obj = {}
        obj = this.subjectsOptions.find((v) => {
          return v.subject_code === item //筛选出匹配数据
        })
        if (obj) {
          arr.push({
            subject_code: obj.subject_code,
            subject_name: obj.subject_name,
          })
        }
      })
      this.form.subjects = arr
    },
    submit(rules) {
      if (this.form.subjects) {
        this.formateSubjects()
      }
      this.$refs[rules].validate((valid) => {
        if (valid) {
          delete this.form.creator
          delete this.form.watcher
          delete this.form.salesman
          this.$emit('submit', {
            form: Object.assign({}, this.form, {
              apply_direction_code: this.form.apply_direction
                ? this.form.apply_direction.value
                : '',
              apply_direction_name: this.form.apply_direction
                ? this.form.apply_direction.label
                : '',
            }),
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 选择院校options搜索出name（后台数据需要name和code两个参数）
    collegeChoose(e) {
      let obj = {}
      obj = this.$store.state.collegeList.find((item) => {
        return item.code === e //筛选出匹配数据
      })
      this.form.apply_college_code = obj.code
      this.form.apply_college_name = obj.name
      this.getMajorOptions()
    },
    // 选择学院，获取专业代码与专业名称
    majorChoose(e) {
      let obj = {}
      obj = this.majorOptions.find((item) => {
        return item.code === e //筛选出匹配数据
      })
      this.form.apply_major_code = obj.code
      this.form.apply_major_name = obj.name
      this.getMajorInfo(
        this.form.apply_college_code,
        this.form.apply_major_code
      )
      this.getSubjectOptions(
        this.form.apply_college_code,
        this.form.apply_academy_code,
        this.form.apply_major_code
      )
    },
    // 获取学院代码与学院名称
    academyChoose(e) {
      let obj = this.academyOptions.find((item) => {
        return item.academy_code === e //筛选出匹配数据
      })
      this.form.apply_academy_code = obj.academy_code
      this.form.apply_academy_name = obj.academy_name
      this.directionsOptions = obj.directions
      this.$set(this.form, 'apply_direction', {
        label: this.directionsOptions[0].direction,
        value: this.directionsOptions[0].direction_code,
      })
    },
    getMajorOptions() {
      let query = {
        isPaging: 0,
        college_code: this.form.apply_college_code,
      }
      majorlist(query).then((res) => {
        console.log(res)
        this.majorOptions = res.data.list || []
      })
    },
    getSubjectOptions(college_code, academy_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        academy_code: academy_code,
        major_code: major_code,
      }
      subjectlist(query).then((res) => {
        let obj = {
          id: 999,
          subject_code: '999',
          subject_name: '复试课程',
        }
        this.subjectsOptions = res.data.list || []
        this.subjectsOptions.push(obj)
      })
    },
    getMajorInfo(college_code, major_code) {
      let str = adminUrl()
      this.$axios({
        url: `${str}/api/v1/major/info`,
        method: 'get', //可以省略 不写默认是get
        params: {
          college_code: college_code,
          major_code: major_code,
        },
      }).then((res) => {
        this.academyOptions = res.data.academys
        this.directionsOptions = this.academyOptions.find((v) => {
          return this.form.apply_academy_code == v.academy_code
        }).directions
      })
    },
    computedProducts(e) {
      let arr = []
      let num = 0
      e.forEach((item) => {
        let obj = {}
        obj = this.productsOptions.find((v) => {
          return v.id === item //筛选出匹配数据
        })
        num += obj.hours
      })
      this.form.service_hours = num
    },
    onInput(e) {
      // 通过正则过滤小数点后两位
      this.form.service_hours =
        this.form.service_hours.match(/^\d*(\.?\d{0,2})/g)[0]
      this.$message({
        message: '课时最多只能输入两位小数',
        type: 'warning',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.input-with-select {
  margin-bottom: 16px;
}
</style>